import { useState, useRef, DragEvent, ChangeEvent } from 'react';
import { extractFileListFromDataTransfer } from '@/utils/extractFileListFromDataTransfer';

interface UseFileDragAndDropProps {
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
}

export const useFileDragAndDrop = ({ onFileChange, isDisabled }: UseFileDragAndDropProps) => {
  const [isDragging, setIsDragging] = useState(false);
  const dragCounterRef = useRef(0);

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    if (isDisabled) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    dragCounterRef.current += 1;
    if (dragCounterRef.current > 0 && e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    if (isDisabled) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    dragCounterRef.current -= 1;
    if (dragCounterRef.current === 0) {
      setIsDragging(false);
    }
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    if (isDisabled) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    if (isDisabled) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    dragCounterRef.current = 0;

    const fileList = extractFileListFromDataTransfer(e.dataTransfer);

    if (fileList && fileList.length > 0) {
      const syntheticEvent = {
        target: {
          files: fileList,
        },
      } as ChangeEvent<HTMLInputElement>;

      onFileChange(syntheticEvent);
    }
  };

  return {
    isDragging,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
  };
};
